module.exports = __webpack_public_path__ + "static/media/PushtimargImage2.596e9d10.jpg";